import { SavedFilters } from "types";
import {
  CAPTION_PARAMETER,
  ENTITY_TYPE_PARAMETER,
  FLOW_PARAMETER,
  FOLDER_PARAMETER,
  GRANULARITY_PARAMETER,
  ISSUE_CONFIDENCE,
  ISSUE_TYPE_PARAMETER,
  METADATA_SOURCES_PARAMETER,
  SEARCH_TEXT_PARAMETER,
  SEARCH_TEXT_THRESHOLD_PARAMETER,
  SEED_PARAMETER,
  USER_TAGS_PARAMETER,
  VERTEX_CONTEXT,
  VERTEX_ID,
  VERTEX_TYPE,
  VQL_PARAMETER,
} from "helpers/constants/miscellaneous";

export const createQueryParamsFromApiFilters = (filters: SavedFilters) => {
  let queryParams: string = "?";
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      let param = "";
      switch (key as keyof SavedFilters) {
        case "issues":
          param = `${ISSUE_TYPE_PARAMETER}=${encodeURIComponent(
            value as string,
          )}`;
          break;
        case "tags":
          param = `${USER_TAGS_PARAMETER}=${encodeURIComponent(
            value as string,
          )}`;
          break;
        case "caption":
          param = `${SEARCH_TEXT_PARAMETER}=${encodeURIComponent(
            value as string,
          )}`;
          break;
        case "textual_similarity_threshold":
          param = `${SEARCH_TEXT_THRESHOLD_PARAMETER}=${encodeURIComponent(
            value as string,
          )}`;
          break;
        case "entity_type":
          param = `${ENTITY_TYPE_PARAMETER}=${encodeURIComponent(
            value.toUpperCase(),
          )}`;
          break;
        case "path":
          param = `${FOLDER_PARAMETER}=${encodeURIComponent(value as string)}`;
          break;
        case "threshold":
          param = `${GRANULARITY_PARAMETER}=${encodeURIComponent(
            value as string,
          )}`;
          break;
        case "caption_only_filter":
          param = `${CAPTION_PARAMETER}=${encodeURIComponent(value as string)}`;
          break;
        case "anchor_media_id":
          param = `${VERTEX_ID}=${encodeURIComponent(value as string)}`;
          break;
        case "anchor_type":
          param = `${VERTEX_TYPE}=${encodeURIComponent(value as string)}`;
          break;
        case "anchor_context":
          param = `${VERTEX_CONTEXT}=${encodeURIComponent(value as string)}`;
          break;
        case "cluster_id":
          break;
        case "issue_confidence":
          const [x, y] = value.slice(1, -1).split(",");
          param = `${ISSUE_CONFIDENCE}=${encodeURIComponent(`[${x},${y}]`)}`;
          break;
        case "metadata_sources":
          param = `${METADATA_SOURCES_PARAMETER}=${encodeURIComponent(JSON.stringify(value))}`;
          break;

        case "vql":
          param = `${VQL_PARAMETER}=${encodeURIComponent(
            JSON.stringify(value),
          )}`;
          break;
        default:
          param = `${key}=${encodeURIComponent(value as string)}`;
      }
      queryParams += (queryParams.length > 1 ? "&" : "") + param;
    }
  });
  return queryParams;
};

export const preserveAndAppendLabelPropagationParams = (
  targetUrl: string,
  currentSearch: string,
): string => {
  const currentParams = new URLSearchParams(currentSearch);
  const seedParam = currentParams.get(SEED_PARAMETER);
  const flowParam = currentParams.get(FLOW_PARAMETER);

  let updatedUrl = targetUrl;

  if (seedParam) {
    updatedUrl += `&${SEED_PARAMETER}=${seedParam}`;
  }

  if (flowParam) {
    updatedUrl += `&${FLOW_PARAMETER}=${flowParam}`;
  }

  return updatedUrl;
};
